module.exports = __webpack_public_path__ + "img/troy_red_mist_rage.aa11c368.png";